import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { map } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { OrderQueries } from 'src/app/shared/types/get-query';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { ImageService } from 'src/app/services/image.service';
import { MutationQuery } from 'src/app/shared/types/mutation-query.enum';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { MatDialog } from '@angular/material/dialog';
import { OrderMapper } from '../../../services/order-mapper';
import { ColorShots, Order, OrderDetail, OrderStatus } from '../../../models/new/order';
import * as _ from 'lodash';
import { Shot, ShotApprovalStatus } from '../../../models/new/shot';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.component';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AddProductModalComponent } from './add-product-modal/add-product-modal.component';
import { ApproveOrderNoteComponent } from './approve-order-note/approve-order-note';
import { Color, Size, SizeGroup, Style } from '../../../models/new/style';
import { ImageGalleryComponent } from 'src/app/shared/components/image-gallery/image-gallery.component';
import { Warehouse } from 'src/app/shared/types/warehouse.model';
import { Selectable } from 'src/app/shared/types/selectable.type';
import { Paginable } from 'src/app/shared/types/paginable';
import { PaginationFilters } from '../../../models/new/paginationFilters';
import { ResumeMapper } from '../../../services/resume-mapper';
import { ShotResume } from '../../../models/new/shotResume';
import { AccordionService } from 'src/app/services/accordion.service';
import { ManageColorsSizesModalComponent } from './add-product-modal/manage-colors-sizes-modal/manage-colors-sizes-modal.component';
import { SubmitOrderModalComponent } from './submit-order-modal/submit-order-modal.component';

@Component({
	selector: 'bt-company-order-detail-shots',
	standalone: false,
	templateUrl: './company-order-detail-shots.component.html',
	styleUrls: ['./company-order-detail-shots.component.scss']
})
export class CompanyOrderDetailShotsComponent implements OnInit {
	loading: boolean = false;
	currentWarehouse: Warehouse | null = null;
	ShotApprovalStatus = ShotApprovalStatus;
	OrderStatus = OrderStatus;

	orderDetails: Paginable<Selectable<OrderDetail>> = new Paginable<Selectable<OrderDetail>>();
	//dati originali prima del salvataggio
	//originalOrderDetails: Paginable<Selectable<OrderDetail>> = new Paginable<Selectable<OrderDetail>>();
	order: Order | null = null;
	orderDetailsFilters = new PaginationFilters();
	shotResume: ShotResume = new ShotResume();

	constructor(
		private route: ActivatedRoute,
		private appService: AppService,
		private graphQLService: GraphQLService,
		private imageService: ImageService,
		private utilitiesService: UtilitiesService,
		private dialog: MatDialog,
		private destroyRef: DestroyRef,
		private orderMapper: OrderMapper,
		private resumeMapper: ResumeMapper,
		private router: Router,
		private accordionService: AccordionService
	) {}

	ngOnInit(): void {
		this.route.parent?.params.subscribe((params) => {
			const orderId = params['orderId'];

			if (orderId != 'new') {
				this.getOrderInfo(Number(orderId));
			}
		});
	}

	getOrderResume(_orderId: number) {
		this.loading = true;
		this.graphQLService
			.getData(OrderQueries.GET_ORDER_RESUME, { orderId: _orderId })
			.pipe(map((res: any) => this.resumeMapper.toShotResume(res.data.orderShotsResume)))
			.subscribe({
				next: (data: ShotResume) => {
					this.shotResume = data;

					this.getOrderDetails(_orderId);
				},
				error: (err) => {
					this.utilitiesService.showSnackbar('Error during fetching order resume', SnackbarType.Error);
					console.error(err);
					this.loading = false;
				}
			});
	}

	noProducts() {
		return this.orderDetails.items.length == 0;
	}

	allShotsAreApprovedOrRejected() {
		return this.shotResume?.uploadedShots == this.shotResume.approvedShots + this.shotResume.rejectedShots;
	}
	someShotsAreApprovable() {
		return this.shotResume?.uploadedShots > this.shotResume?.approvedShots;
	}
	someShotsAreUploaded() {
		return this.shotResume?.uploadedShots > 0;
	}
	allShotsAre(shotApprovalStatus: ShotApprovalStatus) {
		if (shotApprovalStatus == ShotApprovalStatus.Approved) {
			return this.shotResume?.uploadedShots == this.shotResume.approvedShots;
		} else if (shotApprovalStatus == ShotApprovalStatus.Rejected) {
			return this.shotResume?.uploadedShots == this.shotResume.rejectedShots;
		}
	}
	someProductsAreApprovable() {
		return true;
	}

	approveAllShots(shotApprovalStatus: ShotApprovalStatus) {
		this.dialog
			.open(ConfirmModalComponent, {
				data: {
					title: shotApprovalStatus == ShotApprovalStatus.Approved ? 'Approve All Shots' : 'Reject All Shots',
					message: 'Are you sure you want to ' + (shotApprovalStatus == ShotApprovalStatus.Approved ? 'approve' : 'reject') + ' all shots?'
				}
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.loading = true;
						this.graphQLService
							.getData(OrderQueries.UPDATE_SHOT_STATUS_BY_ORDER_ID, { updateShotStatusByOrderIdInput: { orderId: this.order?.id, statusId: shotApprovalStatus } })

							.subscribe({
								next: (data: any) => {
									console.log('approve all shots', data);

									this.loading = false;

									if (this.order?.id) {
										this.getOrderResume(this.order.id);
										this.getOrderDetails(this.order.id);
									}
								},
								error: (err) => {
									this.utilitiesService.showSnackbar(err.networkError.error.errors[0].message || 'Error during approving all shots', SnackbarType.Error);
									console.error(err);
									this.loading = false;
								}
							});
					}
				}
			});
	}

	pageEvent(event: { pageNumber: number; pageSize: number }) {
		this.orderDetails.currentPage = event.pageNumber;
		this.orderDetails.size = event.pageSize;

		this.orderDetailsFilters.page = event.pageNumber;
		this.orderDetailsFilters.size = event.pageSize;

		this.refreshNavigation();
	}

	refreshNavigation() {
		this.loading = true;

		this.router.navigate([location.pathname], {
			queryParams: { page: this.orderDetailsFilters.page, size: this.orderDetailsFilters.size }
		});
	}

	getOrderInfo(_orderId: number): void {
		this.loading = true;
		this.graphQLService
			.getData(OrderQueries.GET_ORDERS, { where: { orderId: { eq: _orderId } }, first: 1 })
			.pipe(map((res: any) => this.orderMapper.toOrder(res.data.orders.nodes[0])))
			.subscribe({
				next: (data: Order) => {
					this.order = data;

					if (this.order.warehouse) {
						this.currentWarehouse = _.cloneDeep(this.order.warehouse);
					}

					this.getOrderResume(this.order.id!);
				},
				error: (err) => {
					this.utilitiesService.showSnackbar('Error during fetching order info', SnackbarType.Error);
					console.error(err);
					this.loading = false;
				}
			});
	}

	getOrderDetails(orderId: number): void {
		this.loading = true;

		this.route.queryParams.subscribe((params: Params) => {
			this.orderDetailsFilters = new PaginationFilters();
			this.orderDetailsFilters.page = params['page'] ? Number(params['page']) : 1;
			this.orderDetailsFilters.size = params['size'] ? Number(params['size']) : 20;

			this.orderDetails.currentPage = this.orderDetailsFilters.page || 1;
			this.orderDetails.size = this.orderDetailsFilters.size || 20;

			const pagination = this.orderDetails.buildQuery(this.orderDetails.currentPage);

			this.graphQLService
				.getData(OrderQueries.GET_ORDER_DETAILS, {
					orderId: orderId,
					...pagination
				})
				.pipe(
					map((res: any) => {
						const orderDetails = res.data.orderDetails;

						//stampa in console lo stato di accordionService
						const paginable = new Paginable<Selectable<OrderDetail>>({
							items: orderDetails.nodes.map((csd: any) => {
								return {
									...this.orderMapper.toOrderDetail(csd),
									selected: false,
									opened: true
								};
							})
						});

						//nella warehousearticle, filtro solo i colori del magazzino selezionto, se esiste
						if (this.currentWarehouse) {
							paginable.items.forEach((item: Selectable<OrderDetail>) => {
								if (item.style?.warehouseArticles) item.style.warehouseArticles = item.style?.warehouseArticles?.filter((wa) => wa.warehouse?.id == this.currentWarehouse?.id);
							});
						}

						paginable.totalCount = orderDetails.totalCount;
						paginable.currentPage = this.orderDetailsFilters.page || 1;
						paginable.size = this.orderDetailsFilters.size || 2;

						return paginable;
					})
				)
				.subscribe({
					next: (data) => {
						this.orderDetails = data;
						//this.originalOrderDetails = _.cloneDeep(data);

						this.loading = false;
					},
					error: (err) => {
						this.utilitiesService.showSnackbar('Error during fetching order details', SnackbarType.Error);
						console.error(err);
						this.loading = false;
					}
				});
		});
	}

	getShotsByProduct(product: OrderDetail, status?: ShotApprovalStatus): Shot[] {
		const shots: Shot[] = [];
		this.orderDetails.items.forEach((d) => {
			if (d.style?.modelId !== product.style?.modelId) return;
			d.colorShots?.forEach((csg) => {
				csg.shots?.forEach((shot) => {
					if (status === undefined) {
						shots.push(shot);
					} else if (shot.shotApprovalStatus == status) {
						shots.push(shot);
					}
				});
			});
		});
		return shots;
	}

	getShotIdsByColor(color: ColorShots): number[] {
		const shotIds: number[] = [];
		this.orderDetails.items.forEach((d) => {
			d.colorShots?.forEach((csg) => {
				if (csg.color?.id === color.color?.id) {
					csg.shots?.forEach((shot) => {
						if (shot.id && shot.shotApprovalStatus != ShotApprovalStatus.NotUploaded) shotIds.push(shot.id);
					});
				}
			});
		});
		return shotIds;
	}

	someShotsAreRejected(product: OrderDetail) {
		let rejected = false;
		this.orderDetails.items.forEach((d) => {
			if (d.style?.modelId !== product.style?.modelId) return;
			d.colorShots?.forEach((csg) => {
				csg.shots?.forEach((shot) => {
					if (shot.shotApprovalStatus == ShotApprovalStatus.Rejected) {
						rejected = true;
					}
				});
			});
		});
		return rejected;
	}

	viewGallery(shots: Shot[]): void {
		this.dialog
			.open(ImageGalleryComponent, {
				data: { shots: shots }
			})
			.afterClosed()
			.subscribe((result) => {
				if (result) {
					// handle result if needed
				}
			});
	}

	getShotsWithImages(colorShots: ColorShots): Shot[] {
		return colorShots.shots?.filter((s) => s.imgPath) || [];
	}

	removeProduct(product: Selectable<OrderDetail>) {
		this.dialog
			.open(ConfirmModalComponent, {
				data: {
					title: 'Remove Product',
					message: 'Are you sure you want to remove "' + product.style?.name + ' - ' + product.style?.code + '"?'
				}
			})
			.afterClosed()
			.subscribe((res) => {
				if (res) {
					this.loading = true;
					this.graphQLService.postData(MutationQuery.REMOVE_PRODUCTS_FROM_ORDER, { removeProductsFromOrderInput: { orderId: this.order?.id!, modelIds: [product.style?.modelId!] } }).subscribe({
						next: (res: any) => {
							this.loading = false;
							this.utilitiesService.showSnackbar('Product removed successfully', SnackbarType.Success);
							this.ngOnInit();
						},
						error: (err) => {
							this.loading = false;
							this.utilitiesService.showSnackbar(err.networkError.error.errors[0].message || 'Error during removing product from order', SnackbarType.Error);
						}
					});
				}
			});
	}

	removeColor(product: Selectable<OrderDetail>, color: Color) {
		this.dialog
			.open(ConfirmModalComponent, {
				data: {
					title: 'Remove Color',
					message: 'Are you sure you want to remove "' + color.name + '" color from "' + product.style?.name + ' - ' + product.style?.code + '"?'
				}
			})
			.afterClosed()
			.subscribe((res) => {
				if (res) {
					this.loading = true;
					this.graphQLService.postData(MutationQuery.REMOVE_COLORS_FROM_PRODUCT, { removeColorsFromProductInput: { orderId: this.order?.id!, modelId: product.style?.modelId!, colorIds: [color.id!] } }).subscribe({
						next: (res: any) => {
							this.loading = false;
							this.utilitiesService.showSnackbar('Color removed successfully', SnackbarType.Success);
							this.ngOnInit();
						},
						error: (err) => {
							this.loading = false;
							this.utilitiesService.showSnackbar(err.networkError.error.errors[0].message || 'Error during removing color from product', SnackbarType.Error);
						}
					});
				}
			});
	}

	addProductModal(): void {
		this.dialog
			.open(AddProductModalComponent, {
				data: { warehouse: this.currentWarehouse ?? null }
			})
			.afterClosed()
			.subscribe((result: { warehouse: Warehouse; styles: Style[] }) => {
				if (!result) return;

				this.loading = true;

				if (this.currentWarehouse == null) {
					this.currentWarehouse = _.cloneDeep(result.warehouse);
				}

				this.graphQLService
					.postData(MutationQuery.ADD_PRODUCTS_TO_ORDER, {
						addproductToOrderInput: {
							orderId: this.order?.id!,
							stylesColors: result.styles.map((s: Style) => ({
								modelId: s.modelId,
								colorSizes: s.colors
									? s.colors.map((c) => ({
											colorId: c.id,
											sizeId: c.size?.id
										}))
									: []
							})),
							warehouseId: result.warehouse.id
						}
					})
					.subscribe({
						next: (res: any) => {
							this.ngOnInit();
							this.utilitiesService.showSnackbar('Products added successfully', SnackbarType.Success);
						},
						error: (err) => {
							this.loading = false;
							this.utilitiesService.showSnackbar(err.networkError.error.errors[0].message || 'Error during adding products to order', SnackbarType.Error);
						}
					});
			});
	}

	openManageColorsSizesModal(product: Selectable<OrderDetail>, color: Color): void {
		//siccome il colore si trova in colorShots, metto il colore dentro l'oggetto style

		if (!product.style) return;

		product.style.colors = [];
		product.style.colors?.push(
			new Color({
				id: color.id,
				code: color.code,
				name: color.name,
				size: color.size ? new Size({ id: color.size.id, name: color.size.name }) : undefined
			})
		);

		this.dialog
			.open(ManageColorsSizesModalComponent, {
				data: {
					style: product.style,
					singleColorSelection: true
				}
			})
			.afterClosed()
			.subscribe({
				next: (res: { color: Selectable<Color>; sizesAndQuantity: Selectable<{ size: Size; availableQty: number }>[] }[]) => {
					if (res) {
						this.loading = true;
						this.graphQLService
							.postData(MutationQuery.UPDATE_ORDER_SIZE_QUANTITY, {
								updateOrderSizeQuantityInput: {
									orderId: this.order?.id!,
									modelId: product.style?.modelId!,
									colorId: color.id!,
									sizeId: res[0].sizesAndQuantity.filter((f) => f.selected)[0].size.id!,
									quantity: 1
								}
							})
							.subscribe({
								next: (_res: any) => {
									product.colorShots?.forEach((cs) => {
										if (cs.color?.id == res[0].color.id) {
											if (cs.color) cs.color.size = res[0].sizesAndQuantity.filter((f: any) => f.selected)[0].size;
										}
									});
									this.utilitiesService.showSnackbar('Order size quantity updated successfully', SnackbarType.Success);
									this.loading = false;
								},
								error: (err) => {
									this.loading = false;
									this.utilitiesService.showSnackbar(err.networkError.error.errors[0].message || 'Error during updating order size quantity', SnackbarType.Error);
								}
							});
					}
				}
			});
	}

	downloadShots(shotIds: number[]): void {
		this.loading = true;
		this.imageService.downloadImagesByShotIds(shotIds).subscribe({
			next: (res: Blob) => {
				this.loading = false;
				const url = window.URL.createObjectURL(res);
				window.open(url, '_blank');
				this.utilitiesService.showSnackbar('Download started', SnackbarType.Success);
			},
			error: (err) => {
				this.loading = false;
				//this.utilitiesService.showSnackbar('Failed to start download', SnackbarType.Error);
			}
		});
	}

	downloadAllShots() {
		this.loading = true;
		if (this.order?.id) {
			this.imageService.downloadImagesByOrderIds([this.order.id]).subscribe({
				next: (res: Blob) => {
					this.loading = false;
					const url = window.URL.createObjectURL(res);
					window.open(url, '_blank');
				},
				error: (err) => {
					this.loading = false;
					//this.utilitiesService.showSnackbar('Failed to start download', SnackbarType.Error);
				}
			});
		}
	}

	thereAreImages(): boolean {
		return this.shotResume.uploadedShots > 0 || this.shotResume.approvedShots > 0 || this.shotResume.rejectedShots > 0;
	}

	copyToClipboard(text: string): void {
		navigator.clipboard
			.writeText(text)
			.then(() => {
				this.utilitiesService.showSnackbar('Filename copied to clipboard', SnackbarType.Success);
			})
			.catch((err) => {
				this.utilitiesService.showSnackbar('Failed to copy filename', SnackbarType.Error);
				console.error(err);
			});
	}

	approveShots(shotIds: number[], status: number): void {
		//filtro sempre per gli shot id che hanno tassativamente lo stato uploaded
		shotIds = shotIds.filter((id) => {
			let shotStatus;
			this.orderDetails.items.forEach((d: OrderDetail) => {
				d.colorShots?.forEach((csg) => {
					csg.shots?.forEach((shot) => {
						if (shot.id == id) {
							shotStatus = shot.shotApprovalStatus;
						}
					});
				});
			});
			return shotStatus == ShotApprovalStatus.Uploaded || shotStatus == ShotApprovalStatus.Rejected || shotStatus == ShotApprovalStatus.Approved ? true : false;
		});

		this.loading = true;

		this.dialog
			.open(ApproveOrderNoteComponent, { data: status })
			.afterClosed()
			.subscribe({
				next: (result) => {
					this.loading = false;
					if (result != undefined) {
						const variables = {
							shotIds,
							statusId: status
							/*comments: result*/
						};
						this.loading = true;
						this.graphQLService
							.postData(MutationQuery.UPDATE_SHOT_STATUS, { updateShotStatusInput: variables })
							.pipe(takeUntilDestroyed(this.destroyRef))
							.subscribe({
								next: (res) => {
									this.loading = false;
									if ((res.data as any).updateShotStatus.success) {
										this.orderDetails.items.forEach((d: OrderDetail) => {
											d.colorShots?.forEach((csg) => {
												csg.shots?.forEach((shot) => {
													if (shot.id)
														if (shotIds.includes(shot.id)) {
															shot.shotApprovalStatus = status;
														}
												});
											});
										});

										this.utilitiesService.showSnackbar('Shot approval state changed successfully', SnackbarType.Success);

										if (this.order?.id) this.getOrderResume(this.order.id);
									}
								},
								error: (err) => {
									this.loading = false;
									this.utilitiesService.showSnackbar(err.networkError.error.errors[0].message || 'Error during shot approvation', SnackbarType.Error);
									console.error(err);
								}
							});
					}
				}
			});
	}

	forbiddenEdit() {
		return this.order?.status?.id == OrderStatus.Submitted || this.order?.status?.id == OrderStatus.ReadyForPickup || this.order?.status?.id == OrderStatus.ShootCompleted || this.order?.status?.id == OrderStatus.Rejected || this.order?.status?.id == OrderStatus.InProgress || this.order?.status?.id == OrderStatus.Approved;
	}

	sendToPhotographer() {
		this.dialog
			.open(ConfirmModalComponent, {
				data: {
					title: 'Confirm',
					message: 'Are you sure you want to  this order approvation to ' + this.order?.photographer?.fullName + '?'
				}
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						//chiama l'UPDATE_ORDER_STATUS con order status Rejected se contiene shot rejected, altrimenti Approved
						const hasRejectedShots = this.orderDetails.items.some((d: OrderDetail) => d.colorShots?.some((csg) => csg.shots?.some((shot) => shot.shotApprovalStatus == ShotApprovalStatus.Rejected)));

						let payload = {
							orderId: this.order?.id,

							orderStatusId: hasRejectedShots ? OrderStatus.Rejected : OrderStatus.Approved
						};

						this.loading = true;
						this.graphQLService.postData(MutationQuery.UPDATE_ORDER_STATUS, { updateOrderStatusInput: payload }).subscribe({
							next: (value: any) => {
								if (this.order && this.order.status) {
									this.order.status.id = hasRejectedShots ? OrderStatus.Rejected : OrderStatus.Approved;
								}
								this.loading = false;
								this.ngOnInit();
								this.utilitiesService.showSnackbar('Order sent to photographer successfully', SnackbarType.Success);
							},
							error: (err) => {
								this.loading = false;
								this.utilitiesService.showSnackbar(err.networkError.error.errors[0].message || 'Error during sending order to photographer', SnackbarType.Error);
								console.error(err);
							}
						});
					}
				}
			});
	}

	setAsReadyForPickup() {
		this.dialog
			.open(ConfirmModalComponent, {
				data: {
					title: 'Confirm',
					message: 'Are you sure you want to set this order as Ready for Pickup?'
				}
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						let payload = {
							orderId: this.order?.id,
							orderStatusId: OrderStatus.ReadyForPickup
						};

						this.loading = true;
						this.graphQLService.postData(MutationQuery.UPDATE_ORDER_STATUS, { updateOrderStatusInput: payload }).subscribe({
							next: (value: any) => {
								if (this.order && this.order.status) {
									this.order.status.id = OrderStatus.ReadyForPickup;
								}
								this.loading = false;
								this.ngOnInit();
								this.utilitiesService.showSnackbar('Order set as Ready for Pickup successfully', SnackbarType.Success);
							},
							error: (err) => {
								this.loading = false;
								this.utilitiesService.showSnackbar(err.networkError.error.errors[0].message || 'Error during setting order as Ready for Pickup', SnackbarType.Error);
								console.error(err);
							}
						});
					}
				}
			});
	}

	submitOrder() {
		this.dialog
			.open(SubmitOrderModalComponent, {
				data: { order: this.order }
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						let payload = {
							orderId: this.order?.id,
							orderStatusId: OrderStatus.Submitted
						};

						this.loading = true;
						this.graphQLService.postData(MutationQuery.UPDATE_ORDER_STATUS, { updateOrderStatusInput: payload }).subscribe({
							next: (value: any) => {
								if (this.order && this.order.status) {
									this.order.status.id = OrderStatus.Submitted;
								}
								this.loading = false;
								this.ngOnInit();

								this.utilitiesService.showSnackbar('Order submitted successfully', SnackbarType.Success);
							},
							error: (err) => {
								this.loading = false;
								this.utilitiesService.showSnackbar(err.networkError.error.errors[0].message || 'Error during submission', SnackbarType.Error);
								console.error(err);
							}
						});
					}
				}
			});
	}

	toggle(product: Selectable<OrderDetail>) {
		product.opened = !product.opened;

		this.accordionService.companyOrderDetailsState.set(product.style?.modelId!, product.opened);
	}
}
